import React, { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import KitBuilder from './components/KitBuilder';
import ProductGrid from './components/ProductGrid';
import ComparisonTable from './components/ComparisonTable';
import Reviews from './components/Reviews';
import FAQ from './components/FAQ';
import ShippingReturns from './components/ShippingReturns';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import Toast from './components/Toast';
import { AnimatePresence } from 'framer-motion';

function App() {
  const [cartItems, setCartItems] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [toasts, setToasts] = useState([]);

  const addToast = (message, type = 'success') => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, message, type }]);
  };

  const removeToast = (id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  };

  const addToCart = (product) => {
    setCartItems(prev => [...prev, product]);
    addToast(`${product.name} deployed to cart`);
  };

  const removeFromCart = (index) => {
    const item = cartItems[index];
    setCartItems(prev => prev.filter((_, i) => i !== index));
    addToast(`${item.name} removed from inventory`, 'info');
  };

  return (
    <div className="min-h-screen bg-asphalt-dark flex flex-col font-body selection:bg-signal selection:text-white">
      <Navbar 
        cartCount={cartItems.length} 
        onOpenCart={() => setIsCartOpen(true)} 
      />
      
      <main className="flex-grow">
        <Hero />
        
        <div id="builder" className="border-t border-white/5">
          <KitBuilder onAddKit={(kit) => {
            setCartItems(prev => [...prev, ...Object.values(kit)]);
            addToast('System Bundle configured and deployed');
          }} />
        </div>
        
        <div id="shop" className="border-t border-white/5">
          <ProductGrid onAddToCart={addToCart} />
        </div>
        
        <div id="compare" className="border-t border-white/5">
          <ComparisonTable />
        </div>
        
        <div id="reviews" className="border-t border-white/5">
          <Reviews />
        </div>
        
        <div id="faq" className="border-t border-white/5">
          <FAQ />
        </div>
        
        <div className="border-t border-white/5">
          <ShippingReturns />
        </div>
      </main>

      <Footer />

      <CartDrawer 
        isOpen={isCartOpen} 
        onClose={() => setIsCartOpen(false)} 
        items={cartItems}
        onRemove={removeFromCart}
      />

      <AnimatePresence>
        {toasts.map(toast => (
          <Toast 
            key={toast.id} 
            message={toast.message} 
            type={toast.type} 
            onClose={() => removeToast(toast.id)} 
          />
        ))}
      </AnimatePresence>
    </div>
  );
}

export default App;